import qs from 'qs';
import request from '@/utils/service';
import serverconfig from '@/api/server.config';

/**
 * 登录接口 获取用户信息
 * @param params {code: code}
 */
export function loginByCode(params) {
  return request({
    headers: {
      'Content-Type': 'application/json',
      clientId: 'wpg_wx',
      Authorization: serverconfig.CLIENT_TOKEN // 已写入配置文件
    },
    url: `/client/wx/${params.code.appId}/get/userInfo/${params.code.wxCode}`, // 网厅
    method: 'get'
    // params
  });
}

export function getToken() {
  return request({
    headers: {
      'Content-Type': 'application/json',
      clientId: 'wpg_wx'
    },
    url: `/auth/oauth/token?scope=trust&grant_type=password&username=tladmin&password=QVsYj@AY,WWcem7c`, // 网厅
    method: 'get'
  });
}

// 获取全局 client token（替代原 VUE_APP_CLIENT_TOKEN 配置）
export function getClientToken() {
  return request({
    url: `/client/vx/getToken`,
    method: 'get',
    // 时间戳参数 + no-cache
    params: { t: Date.now() },
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    },
    hideloading: true
  });
}

export function createJsApiSignature(params) {
  return request({
    url: `/client/wx/${params.appId}/createJsApiSignature`,
    method: 'post',
    data: params.pageUrl,
    headers: {
      Authorization: serverconfig.CLIENT_TOKEN,
      clientId: 'wpg_wx',
      'Content-Type': 'application/json'
    }
  });
}

export function sync(clientCode) {
  return request({
    url: `/client/wx/{appId}/sync/${clientCode}`,
    method: 'get'
  });
}

/**
 * 获取微信 js sdk权限
 */

export function jssdkAuto(params) {
  return request({
    url: '/cdwthirdwxpayapi/jsSdk/config',
    method: 'get',
    params
  });
}

/**
 * 查询用水户信息
 * @param {*} params
 */

export function getWaterUserAddress(params) {
  return request({
    url: '/cdwwechatapi/wechatPublic/getWaterAcountAddress',
    method: 'get',
    params
  });
}

/**
 * 绑定用水户
 * */

export function bingWaterAcount(params) {
  return request({
    url: '/cdwwechatapi/wechatPublic/bingWaterAcount',
    method: 'post',
    data: params
  });
}

/**
 * 查询当前会员下绑定用水户
 */
export function queryBindUsers(params) {
  return request({
    url: '/cdwwechatapi/wechatPublic/getWaterAcountByCustomer',
    method: 'get',
    params
  });
}

/**
 * 统一下单
 * @param {*} params
 */
export function wxJsPay(params) {
  return request({
    url: '/cdwthirdwxpayapi/unifiedOrder/wxJsPay',
    method: 'post',
    data: params
  });
}

/**
 * 获取当前租户下所有商品
 */

export function allProduct() {
  return request({
    url: '/cdwwechatapi/wechatPublic/allProduct',
    method: 'get'
  });
}

/**
 * 下单生成预付单
 */

export function paymentOrder(data) {
  return request({
    url: '/cdwwechatapi/wechatPublic/payment',
    method: 'post',
    data
  });
}

/**
 *  个人中心
 *  积分记录
 */

export function getPointDetail(data) {
  return request({
    url: '/cdwwechatapi/wechatPublic/getPointDetail',
    method: 'post',
    data
  });
}

/**
 *  个人中心
 *  解绑用水户
 */

export function unbundlingWaterAcount(params) {
  return request({
    url: '/cdwwechatapi/wechatPublic/unbundlingWaterAcount',
    method: 'get',
    params
  });
}

// 用水统计
export function payDetails(params) {
  return request({
    url: `/biz/remote/revenue/select/payDetails`,
    method: 'post',
    data: params
  });
}

export function selectWaterUserDetails(clientCode) {
  return request({
    url: `/biz/remote/revenue/select/waterUser?clientCode=${clientCode}`,
    method: 'get'
  });
}

export function selectWaterUserParams(param) {
  return request({
    url: `/biz/remote/revenue/select/waterUser?clientCode=${param.clientCode}&clientPhone=${param.clientPhone}&clientIdNum=${param.clientIdNum}`,
    method: 'get'
  });
}

// 用水统计
export function meterReadList(params) {
  return request({
    url: `/biz/remote/revenue/select/meterReadList?mrMonth=${params.mrMonth}&userId=${params.userId}`,
    method: 'get'
  });
}

// 用水统计
export function waterArrear(params) {
  return request({
    url: `/biz/remote/revenue/select/waterArrear`,
    method: 'get',
    data: params
  });
}

// 账单详情
export function waterArrearDetails(params) {
  return request({
    url: `/client/remote/revenue/select/waterUserDetails?clientCode=${params}`,
    method: 'get',
    data: params
  });
}

// 我的反馈
export function selectFeedbackHandling(params) {
  return request({
    url: `/biz/remoteBiz/api/handle/page`,
    method: 'post',
    data: params
  });
}

/* ------------------------ 分割线 -------------------------- */
export function getBindList(accountId) {
  return request({
    url: `/netAuth/bind/getBindList/${accountId}`,
    method: 'get'
  });
}

export function getUnBind(params) {
  return request({
    url: `/netAuth/bind/unBindClient`,
    method: 'post',
    data: params
  });
}

// 查询用水户列表
export function selectWaterUserList(data) {
  return request({
    url: '/back/revenue/selectWaterUserList',
    method: 'post',
    data
  });
}

// 移动助手处新的查询用水户列表方式
export function superWaterUserList(data) {
  return request({
    url: '/back/revenue/superWaterUserList',
    method: 'post',
    data
  });
}

export function queryChargeCountCompare(data) {
  return request({
    url: '/biz/remote/revenue/queryChargeCountCompare',
    method: 'post',
    data
  });
}

export function chargeCountCompare(data) {
  return request({
    url: '/client/remote/revenue/select/chargeCountCompare',
    method: 'post',
    data
  });
}

export function arrearInfos(data) {
  return request({
    url: '/client/remote/revenue/select/arrearInfos',
    method: 'post',
    data,
    hideloading: true
  });
}

export function getChargeAmount(data) {
  return request({
    url: '/client/bind/queryArrearsByClientNo',
    method: 'post',
    data,
    hideloading: true
  });
}

export function bindClient(data) {
  return request({
    url: '/netAuth/bind/bindClient',
    method: 'post',
    data
  });
}

//查询抄表账单记录-用水分析
export function selectMrReadList(data) {
  return request({
    url: '/back/revenue/selectMrReadList',
    method: 'post',
    data
  });
}

//工单附件上传
export function orderFileUpload(data) {
  return request({
    url: '/back/fileOpt/orderFileUpload',
    method: 'post',
    data
  });
}
// 解绑用水户
export function unBindClient(data) {
  return request({
    url: '/back/waterUser/unBindClient',
    method: 'post',
    data
  });
}

export function submitBussiness(data) {
  return request({
    url: '/client/remoteBiz/api/form/post',
    method: 'post',
    data
  });
}

// 查询开票信息
export function getInvoice(accountId) {
  return request({
    url: `/back/accountInvoice/getInvoice/${accountId}`,
    method: 'get'
  });
}

// 添加开票信息
export function addInvoice(data) {
  return request({
    url: '/back/accountInvoice/addInvoice',
    method: 'post',
    data
  });
}

// 修改开票信息
export function updateInvoice(data) {
  return request({
    url: '/back/accountInvoice/updateInvoice',
    method: 'post',
    data
  });
}

// 删除开票信息
export function deleteInvoice(data) {
  return request({
    url: '/back/accountInvoice/deleteInvoice',
    method: 'post',
    data
  });
}

// 查询用水户详情
// export function selectWaterUserDetails(data) {
//   return request({
//     url: "/back/revenue/selectWaterUserDetails",
//     method: "post",
//     data
//   });
// }

// 查询已订阅微信模板消息
export function getSubWxtemplateList(id) {
  return request({
    url: `/publicaccount/nethall/templatesub/getSubWxtemplateList?accountId=${id}`,
    method: 'post'
  });
}
// 订阅微信模板消息
export function subWxtemplateMsg(param) {
  return request({
    url: `/publicaccount/nethall/templatesub/subWxtemplateMsg?accountId=${param.id}&templateCodes=${param.code}`,
    method: 'post'
  });
}
// 取消订阅微信模板消息
export function unSubWxtemplateMsg(param) {
  return request({
    url: `/publicaccount/nethall/templatesub/unSubWxtemplateMsg?accountId=${param.id}&templateCodes=${param.code}`,
    method: 'post'
  });
}

//电子发票
// 查询开票信息
export function getInvoiceList(yhid) {
  return request({
    url: `/back/invoice/listCb?yhid=${yhid}`,
    method: 'get'
  });
}
// 申请发票
export function applyInvoice(data) {
  return request({
    url: '/back/invoice/applyInvoice',
    method: 'post',
    data
  });
}
// 查询开票信息接口
export function getBillDetails(yhid) {
  return request({
    url: `/back/revenue/yhxx?yhid=${yhid}`,
    method: 'get'
  });
}

// 申请发票
export function applyOpenBill(sflsh) {
  return request({
    url: `/back/invoice/apply?sflsh=${sflsh}`,
    method: 'post',
    hideloading: true
  });
}

// 修改开票信息
export function editBillInfo(data) {
  return request({
    url: `/back/revenue/editKpxx`,
    method: 'post',
    data,
    hideloading: true
  });
}

export function previewPdf(data) {
  return request({
    url: `/back/invoice/previewPdf?fpdm=${data.fpdm}&fphm=${data.fphm}`,
    responseType: 'arraybuffer',
    method: 'get'
  });
}

// 查询欠费记录
export function selectArrearsList(data) {
  return request({
    url: '/back/revenue/selectArrearsList',
    method: 'post',
    data
  });
}

// 查询用户信息
export function getRevenue(yhid) {
  return request({
    url: `/back/revenue/yhxx?yhid=${yhid}`,
    method: 'get'
  });
}

// 站点信息
export function queryAbodeInfo() {
  return request({
    url: `/back/revenue/queryAbodeInfo`,
    method: 'post'
  });
}

// 根据户号查询
export function queryClientXqzb(data) {
  return request({
    url: `/back/revenue/queryClientXqzb`,
    method: 'post',
    data
  });
}

export function queryDictInfo(data) {
  return request({
    url: `/back/revenue/queryDictInfo`,
    method: 'post',
    data
  });
}

export function selectMenuList(params) {
  return request({
    url: `/client/remoteMenu/api/list?flag=true`,
    method: 'get'
  });
}

export function selectNoticeList(params) {
  return request({
    url: `/client/remoteNotice/api/selectNoticePage`,
    method: 'post',
    data: params
  });
}

export function selectNoticeDetail(params) {
  return request({
    url: `/client/remoteNotice/api/selectNoticeDetail/${params}`,
    method: 'get'
  });
}

export function cardInfos(params) {
  return request({
    url: `/client/remote/revenue/select/cardInfos?clientNo=${params.clientNo}`,
    method: 'post',
    data: params
    // headers: {
    //   'content-type': 'application/x-www-form-urlencoded'
    // }
  });
}

//发送短信验证码
export function getPhoneCode(params) {
  return request({
    url: '/client/remote/waterUser/api/msg/sendVerifyCode',
    method: 'post',
    data: params
  });
}

//验证短信码
export function checkedCode(params) {
  return request({
    url: '/client/remote/waterUser/api/msg/checkVerifyCode',
    method: 'post',
    data: params
  });
}

//获取图形验证码
export function getImageCode(params) {
  return request({
    url: `/client/validate/generateValidateCode?accountId=${params}`,
    method: 'post',
    data: null
  });
}

export function selectClientNO(param) {
  return request({
    url: `/client/remote/revenue/select/getClientNoByMeterCode?meterCode=${param.meterCode}`,
    method: 'post',
    data: param
  });
}

export function calcReadNum(param) {
  return request({
    url: `/client/remoteNotice/api/read/${param}`,
    method: 'get'
  });
}

export function sysApplicationWhitelist(param) {
  return request({
    url: `/biz/system/sysApplicationWhitelist`,
    method: 'post',
    data: param
  });
}

export function getNoticeMenu() {
  return request({
    url: `/biz/dict/items/NETHALL_NOTICE_TYPE`,
    method: 'get'
  });
}
